// extracted by mini-css-extract-plugin
export default {"darkgray":"#121212","lightgray":"#333","bordergray":"#959595","white":"#fff","offwhite":"#f1f1f1","lightblue":"#0cc2eb","primary":"#27a1fc"};